<template>
    <div class="about-me-container">
    <h2>About Me</h2>
    <div class="user-info">
        <p><strong>User Id:</strong> {{ userData?.id }}</p>
        <p><strong>Name:</strong> {{ userData?.name }}</p>
        <p><strong>Role:</strong> {{ role }}</p>
        <p><strong>Mail:</strong> {{ userData?.mail }}</p>
        <p><strong>Invoice Address:</strong> {{ userData?.invoiceAddress }}</p>
        <p><strong>Invoice Mail:</strong> {{ userData?.invoiceMail }}</p>
        <p><strong>Invoice Mobile:</strong> {{ userData?.invoiceMobile }}</p>
    </div>

    <p v-if="isLoggedIn">
        <button @click="logout" class="logout-btn">Logout</button>
        <router-link to="/user-edit">
            <button class="create-btn">Edit Profile</button>
        </router-link>
    </p>
    </div>

  </template>
  
  <script lang="ts">
  import { defineComponent } from 'vue'
  import { useAuthStore } from '@/stores/authStore'
   import { useRouter } from 'vue-router'
  
  export default defineComponent({
    setup() {
      const authStore = useAuthStore()
      const router = useRouter()

      if (!authStore.isAuthenticated) {
        // Redirect to login if not authenticated
        router.push('/login')
      }
  
      const logout = () => {
        authStore.logout()
        router.push('/login')
      }
  
      return {
        isLoggedIn: authStore.isAuthenticated,
        userData: authStore.getUserData,
        role : authStore.getRole,
        logout,
      }
    },
  })
  </script>
  

  <style scoped>
/* Container for the entire page */
.about-me-container {
  max-width: 800px;
  margin: 50px auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: Arial, sans-serif;
}

/* Heading Styles */
.about-me-container h2 {
  font-size: 28px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

/* User Info Section */
.user-info {
  margin-bottom: 20px;
}

.user-info p {
  font-size: 16px;
  line-height: 1.5;
  margin: 10px 0;
  color: #555;
}

.user-info p strong {
  font-weight: bold;
  color: #333;
}

/* Logout Button Styles */
.logout-btn {
  padding: 10px 20px;
  background-color: #f44336; /* Red color for logout */
  color: white;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.logout-btn:hover {
  background-color: #e03131; /* Darker red for hover effect */
  transform: scale(1.05); /* Slight scaling effect */
}

.logout-btn:focus {
  outline: none;
}

/* Button styles */
.create-btn {
  padding: 10px 20px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
  border-radius: 4px;
  transition: background-color 0.3s ease;
  margin-left: 10px;
}

/* Hover effect */
.create-btn:hover {
  background-color: #45a049;
}

</style>